import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const ServiceCta = ({ title, text, bgImage, cta }) => {
    return(
        <>
         <section className="cta-2"
          style={bgImage ? { "--cta2-bg": `url(${bgImage})` } : undefined}>
      <div className="cta-2-overlay">

        {/* HEADING */}
        {title && (
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            {title}
          </motion.h2>
        )}

        {/* TEXT */}
        {text && (
          <motion.p
            className="section-text"
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: true }}
          >
            {text}
          </motion.p>
        )}

        {/* BUTTONS */}
      {cta && (
  <motion.div
    className="cta-2-btns"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.4, duration: 0.5 }}
    viewport={{ once: true }}
  >
    {cta.primary && (
      <Link to={cta.primary.link}>
        <motion.button
          className="primary-btn"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          {cta.primary.text}
        </motion.button>
      </Link>
    )}

    {cta.secondary && (
      <Link to={cta.secondary.link}>
        <motion.button
          className="secondary-btn"
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.95 }}
        >
          {cta.secondary.text}
        </motion.button>
      </Link>
    )}
  </motion.div>
)}

      </div>
    </section>
        </>
    )
}

export default ServiceCta;